import React, { useState } from 'react';
import { NavList } from './NavList';
import { NavItemType } from './NavItem';
import { FiUser, FiList, FiMonitor, FiMail } from 'react-icons/fi';
import { tableStore } from '@/store/table';
import { usePublisherInputStore } from '@/store/police/publisher.input';

export type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
  logoUrl: string;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
};

export const Sidebar = ({ isOpen, onClose, logoUrl, isCollapsed = false, onToggleCollapse }: SidebarProps) => {
  const tableStored = tableStore((state) => state);
  const whitelistInputStore = usePublisherInputStore((state) => state);
  const handleClick = () => {
    tableStored.setCurrentPage(1);
    whitelistInputStore.clear();
  };
  const [navItems] = useState<NavItemType[]>([
    {
      title: 'User Management',
      to: '/users',
      subtitle: 'Manage Users Access of Apilogy',
      icon: <FiUser />,
      handleClick,
    },
    {
      title: 'Publisher Request List',
      to: '/requests',
      subtitle: 'Manage Publisher Requests',
      icon: <FiList />,
      handleClick,
    },
    {
      title: 'Bulk Email',
      to: '/email-blast',
      subtitle: 'Manage Email ',
      icon: <FiMail />,
      handleClick,
    },
    {
      title: 'API Management',
      to: '/apis',
      subtitle: 'Monitor API',
      icon: <FiMonitor />,
      handleClick,
    },
  ]);

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden transition-opacity duration-300"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <aside
        className={`fixed top-[65px] left-0 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 shadow-2xl h-[calc(100vh-65px)] transform transition-all duration-300 ease-in-out z-30 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } ${
          isCollapsed ? 'w-16 lg:w-16' : 'w-72 lg:w-[300px]'
        } lg:fixed lg:translate-x-0 lg:shadow-xl lg:h-[calc(100vh-65px)] lg:block`}
      >
        {/* Navigation */}
        <div className="flex-1 py-6 px-4 flex flex-col h-full">
          {/* Main Navigation */}
          <div className="flex-1">
            {!isCollapsed && (
              <div className="px-3 mb-4">
                <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Main Menu</h3>
              </div>
            )}
            <NavList navItems={navItems} handleClick={handleClick} isCollapsed={isCollapsed} />
          </div>

          {/* Footer - Fixed at bottom */}
          {!isCollapsed && (
            <div className="mt-auto">
              <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-xl p-4 border border-slate-600/50">
                <div className="text-center">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                    <span className="text-white text-sm font-bold">AP</span>
                  </div>
                  <p className="text-xs text-slate-300 font-medium">Admin Portal</p>
                  <p className="text-xs text-slate-400">All rights reserved</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};